/**
 * Swaps a broken avatar for Discord's default one.
 *
 * The stored avatar hash can lag behind Discord: the server re-checks it every
 * few hours, and an avatar changed in between answers 404 on the CDN. The
 * header then showed the browser's broken-image box, which reads as a broken
 * site rather than an old picture.
 *
 * The CSP forbids an inline `onerror`, hence this. An image that failed before
 * the bundle ran fires no event for us, so a finished load with no pixels is
 * treated as the same failure.
 */
export function initAvatarFallback(root: ParentNode = document): void {
  for (const img of root.querySelectorAll<HTMLImageElement>('img[data-avatar-fallback]')) {
    const fallback = img.dataset.avatarFallback;
    if (!fallback) continue;

    const swap = (): void => {
      // Once only: a fallback that fails too must not loop.
      if (img.dataset.avatarFallen) return;
      img.dataset.avatarFallen = '1';
      img.src = fallback;
    };

    if (img.complete && img.naturalWidth === 0 && img.getAttribute('src')) swap();
    else img.addEventListener('error', swap, { once: true });
  }
}
